






















import Vue from 'vue'
import SummaryStepCountsCard from '@/components/patient-stats/graphs/summary-reports/SummaryStepCountsCard.vue'
import SummaryNumberOfAwakeningsCard from '@/components/patient-stats/graphs/summary-reports/SummaryNumberOfAwakeningsCard.vue'
import SummaryMInhalerUsagesCard from '@/components/patient-stats/graphs/summary-reports/SummaryMInhalerUsagesCard.vue'
import SummaryAdherenceCard from '@/components/patient-stats/graphs/summary-reports/SummaryAdherenceCard.vue'
import SummaryShortnessOfBreathCard from '@/components/patient-stats/graphs/summary-reports/SummaryShortnessOfBreathCard.vue'
import SummaryRInhalerUsagesCard from '@/components/patient-stats/graphs/summary-reports/SummaryRInhalerUsagesCard.vue'
import SummaryBodyWeightsCard from '@/components/patient-stats/graphs/summary-reports/SummaryBodyWeightsCard.vue'
import SummaryBodyTemperatureCard from '@/components/patient-stats/graphs/summary-reports/SummaryBodyTemperatureCard.vue'
import SummaryOxygenSaturationsCard from '@/components/patient-stats/graphs/summary-reports/SummaryOxygenSaturationsCard.vue'
import SummaryHeartRateCard from '@/components/patient-stats/graphs/summary-reports/SummaryHeartRateCard.vue'
import SummaryPerfusionIndexCard from '@/components/patient-stats/graphs/summary-reports/SummaryPerfusionIndexCard.vue'
import SummarySystolicBPCard from '@/components/patient-stats/graphs/summary-reports/SummarySystolicBPCard.vue'
import SummaryDiastolicBPCard from '@/components/patient-stats/graphs/summary-reports/SummaryDiastolicBPCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { SummaryReportChartKeys } from '@/constants/patient-stats'
import { ModuleNames } from '@/store/module-names'
import { PatientWithStatsActionNames, PatientWithStatsGetterNames } from '@/store/modules/patient-with-stats/keys'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-detailed-reports/keys'
import { FlatPatientWithDetailedReports } from '@/store/modules/patient-with-detailed-reports/getters'

type ComponentByChartKeys = { [key in SummaryReportChartKeys]?: string }
const componentByChartKeys: ComponentByChartKeys = {
  [SummaryReportChartKeys.StepCounts]: 'SummaryStepCountsCard',
  [SummaryReportChartKeys.Adherence]: 'SummaryAdherenceCard',
  [SummaryReportChartKeys.ShortnessOfBreath]: 'SummaryShortnessOfBreathCard',
  [SummaryReportChartKeys.NumberOfAwakenings]: 'SummaryNumberOfAwakeningsCard',
  [SummaryReportChartKeys.MaintenanceInhalerUsage]: 'SummaryMInhalerUsagesCard',
  [SummaryReportChartKeys.RescueInhalerUsage]: 'SummaryRInhalerUsagesCard',
  [SummaryReportChartKeys.BodyWeight]: 'SummaryBodyWeightsCard',
  [SummaryReportChartKeys.BodyTemperature]: 'SummaryBodyTemperatureCard',
  [SummaryReportChartKeys.OxygenSaturation]: 'SummaryOxygenSaturationsCard',
  [SummaryReportChartKeys.HeartRate]: 'SummaryHeartRateCard',
  [SummaryReportChartKeys.PerfusionIndex]: 'SummaryPerfusionIndexCard',
  [SummaryReportChartKeys.BloodPressureSystolic]: 'SummarySystolicBPCard',
  [SummaryReportChartKeys.BloodPressureDiastolic]: 'SummaryDiastolicBPCard',
}

export default Vue.extend({
  components: {
    SummaryStepCountsCard,
    SummaryNumberOfAwakeningsCard,
    SummaryMInhalerUsagesCard,
    SummaryAdherenceCard,
    SummaryShortnessOfBreathCard,
    SummaryRInhalerUsagesCard,
    SummaryBodyWeightsCard,
    SummaryBodyTemperatureCard,
    SummaryOxygenSaturationsCard,
    SummaryHeartRateCard,
    SummaryPerfusionIndexCard,
    SummarySystolicBPCard,
    SummaryDiastolicBPCard,
  },
  inheritAttrs: false,
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientStatsPageType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false,
      componentByChartKeys,
      colWidthLg: this.$props.patientStatsPageType.columns == 2 ? 6 : 4,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithStats, {
      patientWithStats: PatientWithStatsGetterNames.PatientWithStats,
    }),
    ...mapGetters(ModuleNames.patientWithDetailedReports, {
      patientWithDetailedReports: GetterNames.patientWithDetailedReports,
    }),
    // patientWithDetailedReports(): FlatPatientWithDetailedReports {
    //   return this.patientWithDetailedReports.find(patientWithDR => patientWithDR.id === this.patientId)
    // },
    patientId(): string {
      return this.$route.params.patient_id || ''
    },
  },
  watch: {
    async startTimestamp(n, o): Promise<void> {
      await this.fetchPatientData({ startTimestamp: n })
    },
    async endTimestamp(n, o): Promise<void> {
      await this.fetchPatientData({ endTimestamp: n })
    },
  },
  async mounted(): Promise<void> {
    await this.fetchPatientData()
  },
  methods: {
    ...mapActions(ModuleNames.patientWithStats, [PatientWithStatsActionNames.getPatientWithStatsById]),
    ...mapActions(ModuleNames.patientWithDetailedReports, [ActionNames.getPatientWithDetailedReportsById]),

    async fetchPatientData(options): Promise<void> {
      this.isInitialized = false
      await this[PatientWithStatsActionNames.getPatientWithStatsById]({
        patientId: this.patientId,
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
        ...options,
      })
      await this[ActionNames.getPatientWithDetailedReportsById]({
        patientId: this.patientId,
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
        ...options,
      })
      this.isInitialized = true
    },
  },
})
